import { render } from "./COVIDOccupancyTwoLayout.vue?vue&type=template&id=d8f5e1e0&scoped=true&ts=true"
import script from "./COVIDOccupancyTwoLayout.vue?vue&type=script&lang=ts"
export * from "./COVIDOccupancyTwoLayout.vue?vue&type=script&lang=ts"

import "./COVIDOccupancyTwoLayout.vue?vue&type=style&index=0&id=d8f5e1e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f5e1e0"]])

export default __exports__